import { SiApple, SiWindows } from "solid-icons/si";
import { Dynamic } from "solid-js/web";
import type { DetectedOS } from "~/lib/useOS";

export const PlatformIcon = (props: { os: DetectedOS; class?: string }) => (
  <Dynamic component={props.os === "windows" ? SiWindows : SiApple} class={props.class} aria-hidden="true" />
);
